import { Button } from '@st/theme'

export function OrganizationBillingLoadFailed({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex flex-col items-center gap-3 py-8 text-center text-gray-700" role="alert">
      <div>We could not load billing. Please check your connection and try again.</div>
      <Button variant="primary" onClick={onRetry}>
        Retry
      </Button>
    </div>
  )
}
